import { Directive, HostBinding, Input } from "@angular/core";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[matErrorState]'
})
export class MatErrorStateDirective {
  @Input('matErrorState') control: AbstractControl

  @HostBinding('class.interval-required')
  get intervalRequiredClass() {
    if (!this.control) return false
    const ctlr = this.control
    return !(ctlr.touched && ctlr.invalid) && ctlr.hasError('required')
  }

  @HostBinding('class.interval-error')
  get intervalErrorClass() {
    if (!this.control) return false
    const ctlr = this.control
    return ctlr.touched && ctlr.hasError('required')
  }

  @HostBinding('hidden')
  get hidden() {
    if (!this.control) return false
    const ctlr = this.control
    return ctlr.value !== null && ctlr.value !== '' && ctlr.value !== undefined
  }
}